/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.object.to-string.js";
import Vue from 'vue';
import Router from 'vue-router'; // import store from '../store'

import { routerBefore, routerAfter } from '@/platforms';
import Layout from '@/views/layout';
Vue.use(Router);
var router = new Router({
  routes: [{
    path: '/',
    redirect: '/qrcode',
    name: 'Layout',
    component: Layout,
    children: [{
      path: '/qrcode',
      name: 'Home',
      component: function component() {
        return import('@/views/home/entry/index');
      },
      meta: {
        name: '首页'
      }
    }, {
      path: '/info',
      name: 'Info',
      component: function component() {
        return import('@/views/info');
      },
      meta: {
        name: '设备基本信息'
      }
    }, {
      path: '/companyProfile',
      name: 'CompanyProfile',
      component: function component() {
        return import('@/views/companyProfile');
      },
      meta: {
        name: '企业产品介绍'
      }
    }, {
      path: '/service',
      name: 'Service',
      component: function component() {
        return import('@/views/order/detail/components/accept');
      },
      meta: {
        name: '企业服务上报'
      }
    }, {
      path: '/information/:code',
      name: 'Information',
      props: true,
      component: function component() {
        return import('@/views/information');
      },
      meta: {
        name: '产品相关资料'
      }
    }, {
      path: '/order',
      name: 'Order',
      component: function component() {
        return import('@/views/order/entry');
      },
      meta: {
        name: '服务记录'
      }
    }, {
      path: '/order/accept/:orderId',
      name: 'OrderDetail',
      props: true,
      component: function component() {
        return import('@/views/order/detail');
      },
      meta: {
        name: '维修记录'
      }
    }, {
      path: '/complaint',
      name: 'complaint',
      props: true,
      component: function component() {
        return import('@/views/complaint');
      },
      meta: {
        name: '投诉与建议'
      }
    }, {
      path: '/complaint/vxcomplaint',
      name: 'complaintvx',
      props: true,
      component: function component() {
        return import('@/views/complaint/vxcomplaint');
      },
      meta: {
        name: '投诉与建议'
      }
    }, {
      path: '/complaint/hdcomplaint',
      name: 'complainthd',
      props: true,
      component: function component() {
        return import('@/views/complaint/hdcomplaint');
      },
      meta: {
        name: '投诉与建议'
      }
    }, {
      path: '/expense/enclosure',
      name: 'EnclosureExpense',
      props: function props(route) {
        return {
          code: route.query.expenseId,
          type: 2
        };
      },
      component: function component() {
        return import('@/views/enclosure/Enclosure');
      },
      meta: {
        name: '费用附件'
      }
    }, {
      path: '/apply/enclosure',
      name: 'EnclosureApply',
      props: function props(route) {
        return {
          code: route.query.applyId,
          type: 1
        };
      },
      component: function component() {
        return import('@/views/enclosure/Enclosure');
      },
      meta: {
        name: '配件附件'
      }
    }, {
      path: '/codeLogin',
      name: 'CodeLogin',
      props: function props(route) {
        return route.query;
      },
      component: function component() {
        return import('@/pages/mobile/codeLogin.vue');
      },
      meta: {
        name: '登录'
      }
    }, {
      path: '/register',
      name: 'Register',
      component: function component() {
        return import('@/pages/mobile/register.vue');
      },
      meta: {
        name: '注册'
      }
    }]
  }]
});
router.beforeEach(routerBefore);
router.afterEach(routerAfter);
export default router;